import React, {Component} from 'react';

import PropTypes from 'prop-types';

import * as APPDATA from '@/constants/pcConstAppData';
import {isEmptyFieldValue} from '@/libs/appHelper';

import FmlxNumpad from './FmlxNumpad';

import './NumpadModal.css';

class NumpadModal extends Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.onOkClicked = this.onOkClicked.bind(this);

    // Initiate state for this component
    this.state = {
      inputValue: '0.0',
      readyUpdate: true,
      showWarning: false,
      warningMessage: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {modalVisible} = this.props;

    if (nextProps.value && nextProps.numpadMode !== APPDATA.NUMPAD_MODE_PASSWORD && !modalVisible) {
      this.setState({
        inputValue: nextProps.value.toString(),
        showWarning: false,
        warningMessage: '',
      });
    } else {
      this.setState({
        inputValue: undefined,
        showWarning: false,
        warningMessage: '',
      });
    }
  }

  onOkClicked(numpadId, _value) {
    const {callback, validatorInput, modalHeader} = this.props;

    const value = _value === undefined ? undefined : _value.toString();

    this.setState({
      inputValue: value,
    });

    if (this.isValueWithinThreshold(value)) {
      const callBackValidator = validatorInput({type: numpadId, value});
      if (callBackValidator.isValid) {
        callback({type: modalHeader, value});
        this.close();
      } else {
        this.setState({
          showWarning: true,
          warningMessage: callBackValidator.message,
        });
      }
    } else {
      this.outsideTreshold();
    }
  }

  outsideTreshold = () => {
    const {maxValue, minValue, numpadMode, unit, info} = this.props;
    const passwordMessage = APPDATA.MESSAGES.NUMPAD.MIN_PASSWORD;

    let normalMode = `Value must be ${minValue === 0 ? 'less than' : 'between'} ${
      minValue === 0 ? maxValue : `${minValue} and ${maxValue}`
    } ${unit}${info}`;

    if (isEmptyFieldValue(maxValue)) {
      normalMode = `Value must be at least ${minValue} ${unit}${info}`;
    } else if (isEmptyFieldValue(minValue)) {
      normalMode = `Value must be smaller than ${maxValue} ${unit}${info}`;
    } else if (maxValue === Infinity) {
      normalMode = `Value must be at least ${minValue} ${unit}${info}`;
    }

    const warningMessage = numpadMode === FmlxNumpad.mode.password ? passwordMessage : normalMode;
    this.setState({
      showWarning: true,
      warningMessage,
    });
  };

  // eslint-disable-next-line class-methods-use-this
  onValueChanged = () => {};

  /**
   * Check if value entered by user is within threshold
   * @param {*} value
   */
  isValueWithinThreshold(value) {
    const {minValue, maxValue} = this.props;

    const userInputValue = parseFloat(value);

    if (userInputValue >= minValue && userInputValue <= maxValue) {
      return true;
    }

    return false;
  }

  close() {
    const {onHideModal, modalVisible} = this.props;
    const {readyUpdate, showWarning} = this.state;

    if (!readyUpdate && modalVisible) {
      // reset automatic clear value when numpad show
      this.setState({
        readyUpdate: !readyUpdate,
      });
    }

    if (showWarning) {
      this.setState(
        {
          showWarning: false,
          warningMessage: '',
        },
        onHideModal,
      );
    } else {
      onHideModal();
    }
  }

  newNumpad() {
    const {
      modalVisible,
      modalHeader,
      modalTitle,
      maxDigitAfterDecimal,
      maxValue,
      minValue,
      numpadMode,
      incrementValue,
      unit,
      info,
    } = this.props;

    const {warningMessage, inputValue} = this.state;
    const mainKeys =
      numpadMode === FmlxNumpad.mode.password ? FmlxNumpad.mainKeys.number : FmlxNumpad.mainKeys.calculator;
    const EnableIncDec = numpadMode !== FmlxNumpad.mode.password;

    return (
      <FmlxNumpad
        id={modalHeader}
        value={inputValue}
        title={modalTitle || modalHeader}
        validationText={warningMessage}
        onValueChanged={this.onValueChanged}
        validatorNumber={this.onValidationError}
        incDec={EnableIncDec}
        incrementValue={incrementValue}
        maxDigitAfterDecimal={maxDigitAfterDecimal}
        minValue={minValue}
        maxValue={maxValue}
        isFloatingNumpad
        showFloatingNumpad={modalVisible}
        onClose={this.close}
        onOkClicked={this.onOkClicked}
        floatingNumpadMode={numpadMode}
        mainKeys={mainKeys}
        sideKeys={FmlxNumpad.sideKeys.floating}
        replaceFirstInput
        unit={unit}
        info={info}
      />
    );
  }

  render() {
    return this.newNumpad();
  }
}

NumpadModal.propTypes = {
  maxDigitAfterDecimal: PropTypes.number,
  minValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validatorInput: PropTypes.func,
  numpadMode: PropTypes.oneOf(Object.values(FmlxNumpad.mode)),
  callback: PropTypes.func,
  modalHeader: PropTypes.any,
  modalTitle: PropTypes.any,
  unit: PropTypes.any,
  info: PropTypes.any,
  modalVisible: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  incrementValue: PropTypes.number,
  onHideModal: PropTypes.func,
};

NumpadModal.defaultProps = {
  maxDigitAfterDecimal: 1,
  minValue: '0',
  maxValue: '50',
  validatorInput() {
    return {
      isValid: true,
    };
  },
  numpadMode: FmlxNumpad.mode.normal,
  callback: () => {},
  modalHeader: '',
  modalTitle: '',
  unit: '',
  info: '',
  modalVisible: false,
  value: 0,
  incrementValue: 0,
  onHideModal: () => {},
};

export default NumpadModal;
